import { useDesignBoardPageState } from '@modules/design-board/component/context';
import { Caption, Flex, useStyles } from '@archipro-design/aria';
import React from 'react';
import * as S from '@modules/design-board/component/share-modal/MobileShareBoardModal.style';
import { ChevronDown } from '@archipro-design/icons';
import type {
    MobileBottomMenuData,
} from '@modules/design-board/type/main-context-types';
import type { CollaboratorAccessType } from '@modules/design-board/validation/schemas';
import { permissionTypeLabels } from '@modules/design-board/validation/schemas';

interface CollaboratorPermissionToggleProps {
    bottomMenuData: MobileBottomMenuData;
    permission: CollaboratorAccessType;
    shortDescription?: boolean
}

export const CollaboratorPermissionToggle = ({
    bottomMenuData,
    permission,
    shortDescription,
}: CollaboratorPermissionToggleProps) => {
    const { css } = useStyles({shortDescription});
    const { dispatch, state } = useDesignBoardPageState();

    const onClick = (e: React.SyntheticEvent<HTMLElement>) => {
        e.preventDefault();
        e.stopPropagation();
        dispatch({
            type: 'OpenMobileBottomMenuDrawer',
            bottomMenuData,
        });
    };

    return (
        <Flex
            onClick={onClick}
            space="between"
            className={css(S.PermissionToggle)}
        >
            <Caption variant="03" className={css(S.Description)}>
                {shortDescription ? (
                    <>{permissionTypeLabels[permission]}</>
                ) : (
                    <>Collaborators {permissionTypeLabels[permission]}</>
                )}
            </Caption>
            <div className={css(S.Selector)}>
                {state.isDrawerOpen ? (
                    <ChevronDown className="expanded" />
                ) : (
                    <ChevronDown />
                )}
            </div>
        </Flex>
    );
};
